import { makeHook } from "../../utils/makeSingleArgHook";
import getDocuments, { url } from "../requests/getClientDocuments";
export const docCenterGetDocumentsKeyMaker = (clientId) => [
    url(),
    clientId,
];
const useGetDocuments = makeHook(getDocuments, (clientId) => docCenterGetDocumentsKeyMaker(clientId));
export default useGetDocuments;
//# sourceMappingURL=useGetDocuments.js.map